var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"p-relative"},[_c('heading',{staticClass:"mt-10 z-index-2 p-relative"}),_c('tvl-chart')],1),_c('product-overview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }